// src/api/features.js  —  API functions for Phase 2 feature pages
import { apiGet, apiPost, apiPatch, apiDelete, apiPostForm } from './service';

// ─── Fuzz Campaigns ─────────────────────────────────────────────────
export const listFuzzCampaigns = (params = {}) => {
  const q = new URLSearchParams(params).toString();
  return apiGet(`/api/fuzz-campaigns/${q ? `?${q}` : ''}`);
};
export const createFuzzCampaign = (data) => apiPost('/api/fuzz-campaigns/', data);
export const updateFuzzCampaign = (id, data) => apiPatch(`/api/fuzz-campaigns/${id}/`, data);
export const deleteFuzzCampaign = (id) => apiDelete(`/api/fuzz-campaigns/${id}/`);
export const listFuzzTemplates = (params = {}) => {
  const q = new URLSearchParams(params).toString();
  return apiGet(`/api/fuzz-campaigns/templates/${q ? `?${q}` : ''}`);
};
export const previewFuzzPayloads = (data) => apiPost('/api/fuzz-campaigns/payload-preview/', data);

// ─── Attack Surface ─────────────────────────────────────────────────
export const listAttackSurface = (params = {}) => {
  const q = new URLSearchParams(params).toString();
  return apiGet(`/api/attack-surface/${q ? `?${q}` : ''}`);
};
export const createAttackSurfaceAsset = (data) => apiPost('/api/attack-surface/', data);
export const updateAttackSurfaceAsset = (id, data) => apiPatch(`/api/attack-surface/${id}/`, data);
export const deleteAttackSurfaceAsset = (id) => apiDelete(`/api/attack-surface/${id}/`);
export const attackSurfaceSummary = (params = {}) => {
  const q = new URLSearchParams(params).toString();
  return apiGet(`/api/attack-surface/summary/${q ? `?${q}` : ''}`);
};
export const listAttackSurfaceChanges = (params = {}) => {
  const q = new URLSearchParams(params).toString();
  return apiGet(`/api/attack-surface/changes/${q ? `?${q}` : ''}`);
};
export const runAttackSurfaceDiscovery = (data) => apiPost('/api/attack-surface/run-discovery/', data);
export const scheduleAttackSurfaceMonitoring = (data) => apiPost('/api/attack-surface/schedule-monitoring/', data);

// ─── SBOM ───────────────────────────────────────────────────────────
export const listSbomComponents = (params = {}) => {
  const q = new URLSearchParams(params).toString();
  return apiGet(`/api/sbom/${q ? `?${q}` : ''}`);
};
export const createSbomComponent = (data) => apiPost('/api/sbom/', data);
export const updateSbomComponent = (id, data) => apiPatch(`/api/sbom/${id}/`, data);
export const deleteSbomComponent = (id) => apiDelete(`/api/sbom/${id}/`);
export const matchSbomVulnerabilities = (data) => apiPost('/api/sbom/match-vulnerabilities/', data);

// ─── Secrets Detection ──────────────────────────────────────────────
export const listSecrets = (params = {}) => {
  const q = new URLSearchParams(params).toString();
  return apiGet(`/api/secrets/${q ? `?${q}` : ''}`);
};
export const createSecret = (data) => apiPost('/api/secrets/', data);
export const updateSecret = (id, data) => apiPatch(`/api/secrets/${id}/`, data);
export const deleteSecret = (id) => apiDelete(`/api/secrets/${id}/`);
export const runSecretsHistoryScan = (data) => apiPost('/api/secrets/run-history-scan/', data);

// ─── API Endpoints / API Security ───────────────────────────────────
export const listApiEndpoints = (params = {}) => {
  const q = new URLSearchParams(params).toString();
  return apiGet(`/api/api-endpoints/${q ? `?${q}` : ''}`);
};
export const createApiEndpoint = (data) => apiPost('/api/api-endpoints/', data);
export const updateApiEndpoint = (id, data) => apiPatch(`/api/api-endpoints/${id}/`, data);
export const deleteApiEndpoint = (id) => apiDelete(`/api/api-endpoints/${id}/`);
export const runApiSecurityAudit = (data) => apiPost('/api/api-endpoints/run-audit/', data);

// ─── Engagements ────────────────────────────────────────────────────
export const listEngagements = (params = {}) => {
  const q = new URLSearchParams(params).toString();
  return apiGet(`/api/engagements/${q ? `?${q}` : ''}`);
};
export const createEngagement = (data) => apiPost('/api/engagements/', data);
export const updateEngagement = (id, data) => apiPatch(`/api/engagements/${id}/`, data);
export const deleteEngagement = (id) => apiDelete(`/api/engagements/${id}/`);

// ─── Exploits ───────────────────────────────────────────────────────
export const listExploits = (params = {}) => {
  const q = new URLSearchParams(params).toString();
  return apiGet(`/api/exploits/${q ? `?${q}` : ''}`);
};
export const createExploit = (data) => apiPost('/api/exploits/', data);
export const updateExploit = (id, data) => apiPatch(`/api/exploits/${id}/`, data);
export const deleteExploit = (id) => apiDelete(`/api/exploits/${id}/`);
export const linkExploitFinding = (id, data) => apiPost(`/api/exploits/${id}/link-finding/`, data);
export const unlinkExploitFinding = (id, data) => apiPost(`/api/exploits/${id}/unlink-finding/`, data);
export const listExploitTemplates = (id) => apiGet(`/api/exploits/${id}/templates/`);
export const createExploitTemplate = (id, data) => apiPost(`/api/exploits/${id}/templates/`, data);
export const listExploitAttempts = (id) => apiGet(`/api/exploits/${id}/attempts/`);
export const recordExploitAttempt = (id, data) => apiPost(`/api/exploits/${id}/record-attempt/`, data);

// ─── Knowledge Base ─────────────────────────────────────────────────

// ─── Webhooks ───────────────────────────────────────────────────────
export const listWebhooks = () => apiGet('/api/webhooks/');
export const createWebhook = (data) => apiPost('/api/webhooks/', data);
export const updateWebhook = (id, data) => apiPatch(`/api/webhooks/${id}/`, data);
export const deleteWebhook = (id) => apiDelete(`/api/webhooks/${id}/`);
export const testWebhook = (id) => apiPost(`/api/webhooks/${id}/test/`);
export const listWebhookDeliveries = (id) => apiGet(`/api/webhooks/${id}/deliveries/`);
export const toggleWebhook = (id) => apiPost(`/api/webhooks/${id}/toggle/`);
export const listWebhookEvents = () => apiGet('/api/webhooks/events/');
export const getWebhookActivity = (limit = 100) => apiGet(`/api/webhooks/activity/?limit=${limit}`);
export const replayWebhookDelivery = (delivery) => apiPost('/api/webhooks/replay/', { delivery });

// ─── Scan Templates ─────────────────────────────────────────────────
export const listScanTemplates = (params = {}) => {
  const q = new URLSearchParams(params).toString();
  return apiGet(`/api/scan-templates/${q ? `?${q}` : ''}`);
};
export const createScanTemplate = (data) => apiPost('/api/scan-templates/', data);
export const updateScanTemplate = (id, data) => apiPatch(`/api/scan-templates/${id}/`, data);
export const deleteScanTemplate = (id) => apiDelete(`/api/scan-templates/${id}/`);
export const markScanTemplateUsed = (id) => apiPost(`/api/scan-templates/${id}/use/`, {});

// ─── Cloud Posture (CSPM) ───────────────────────────────────────────
export const listCloudPostureAccounts = (params = {}) => {
  const q = new URLSearchParams(params).toString();
  return apiGet(`/api/cloud-posture/${q ? `?${q}` : ''}`);
};
export const createCloudPostureAccount = (data) => apiPost('/api/cloud-posture/', data);
export const updateCloudPostureAccount = (id, data) => apiPatch(`/api/cloud-posture/${id}/`, data);
export const deleteCloudPostureAccount = (id) => apiDelete(`/api/cloud-posture/${id}/`);
export const listAccountMisconfigurations = (id, params = {}) => {
  const q = new URLSearchParams(params).toString();
  return apiGet(`/api/cloud-posture/${id}/misconfigurations/${q ? `?${q}` : ''}`);
};
export const listAllMisconfigurations = () => apiGet('/api/cloud-misconfigurations/');

// ─── Data Exports ───────────────────────────────────────────────────
export const listDataExports = (params = {}) => {
  const q = new URLSearchParams(params).toString();
  return apiGet(`/api/data-exports/${q ? `?${q}` : ''}`);
};
export const createDataExport = (data) => apiPost('/api/data-exports/', data);
export const updateDataExport = (id, data) => apiPatch(`/api/data-exports/${id}/`, data);
export const runDataExportNow = (id) => apiPost(`/api/data-exports/${id}/run-now/`, {});
export const toggleDataExport = (id, enabled) => apiPost(`/api/data-exports/${id}/toggle/`, { enabled });
export const getDataExportCiSnippets = (id) => apiGet(`/api/data-exports/${id}/ci-snippets/`);
export const getDataExportRetentionSummary = () => apiGet('/api/data-exports/retention-summary/');
export const deleteDataExport = (id) => apiDelete(`/api/data-exports/${id}/`);

// ─── Read-only Shared Links ─────────────────────────────────────────
export const listSharedLinks = (params = {}) => {
  const q = new URLSearchParams(params).toString();
  return apiGet(`/api/shared-links/${q ? `?${q}` : ''}`);
};
export const createSharedLink = (data) => apiPost('/api/shared-links/', data);
export const revokeSharedLink = (id) => apiPost(`/api/shared-links/${id}/revoke/`);
export const deleteSharedLink = (id) => apiDelete(`/api/shared-links/${id}/`);
export const sharedLinkOptions = (type, q = '') => apiGet(`/api/shared-links/options/?type=${type}&q=${encodeURIComponent(q)}`);
export const sharedLinkPreview = (type, id) => apiGet(`/api/shared-links/preview/?type=${type}&id=${encodeURIComponent(id)}`);

// ─── Dashboard Widgets ──────────────────────────────────────────────
export const listDashboardWidgets = () => apiGet('/api/dashboard-widgets/');
export const createDashboardWidget = (data) => apiPost('/api/dashboard-widgets/', data);
export const updateDashboardWidget = (id, data) => apiPatch(`/api/dashboard-widgets/${id}/`, data);
export const deleteDashboardWidget = (id) => apiDelete(`/api/dashboard-widgets/${id}/`);
export const reorderDashboardWidgets = (positions) => apiPost('/api/dashboard-widgets/reorder/', { positions });

// ─── Active Sessions ────────────────────────────────────────────────
export const listActiveSessions = (params = {}) => {
  const query = new URLSearchParams(params).toString();
  return apiGet(`/api/auth/sessions/${query ? `?${query}` : ''}`);
};
export const revokeActiveSession = (id) => apiPost('/api/auth/sessions/', { action: 'revoke', id });
export const revokeOtherActiveSessions = () => apiPost('/api/auth/sessions/', { action: 'revoke_others' });
export const revokeCurrentActiveSession = () => apiPost('/api/auth/sessions/', { action: 'revoke_current' });

// ─── Scan Diff ─────────────────────────────────────────────────────────
export const getScanDiff = (scanAId, scanBId) => apiGet(`/api/scan-diff/?scan_a=${scanAId}&scan_b=${scanBId}`);

// ─── My Work ───────────────────────────────────────────────────────────
export const getMyWork = () => apiGet('/api/my-work/');
export const toggleMyWorkBookmark = (data) => apiPost('/api/my-work/bookmarks/', { ...data, toggle: true });
export const deleteMyWorkBookmark = (id) => apiDelete(`/api/my-work/bookmarks/${id}/`);
export const saveMyWorkFilter = (data) => apiPost('/api/my-work/filters/', data);
export const deleteMyWorkFilter = (id) => apiDelete(`/api/my-work/filters/${id}/`);

// ─── Scans (for selectors) ─────────────────────────────────────────────
export const listUserScans = (params = {}) => {
  const q = new URLSearchParams(params).toString();
  return apiGet(`/api/scans/${q ? `?${q}` : ''}`);
};

// ─── Scan Cancel / Delete ───────────────────────────────────────────────────
export const cancelScan   = (id) => apiPost(`/api/scan-jobs/${id}/cancel/`, {});
export const pauseScan    = (id) => apiPost(`/api/scan-jobs/${id}/pause/`, {});
export const resumeScan   = (id) => apiPost(`/api/scan-jobs/${id}/resume/`, {});
export const deleteScan   = (id) => apiDelete(`/api/scan-jobs/${id}/`);

// ─── Global Active Scans (header badge) ─────────────────────────────────────
export const getActiveScans = () => apiGet('/api/active-scans/');

// ─── Local Console Addon Sync ────────────────────────────────────────────────
export const syncLocalAddonRun = (data) => apiPost('/api/addon/sync/', data);

export const importSbomFile = (userTarget, file) => {
  const form = new FormData();
  form.append('file', file);
  form.append('user_target', userTarget);
  return apiPostForm('/api/sbom/import/', form);
};
